import { render, staticRenderFns } from "./ReleaseFormNew.vue?vue&type=template&id=3eef7a83&"
import script from "./ReleaseFormNew.vue?vue&type=script&lang=js&"
export * from "./ReleaseFormNew.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseFormNew.vue?vue&type=style&index=0&id=3eef7a83&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports